import { call, put, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { fetchProfile } from 'store/session/actions';

import { types, updateDefaultOrganization } from './actions';

export default function* root() {
  yield takeLatest(
    types.UPDATE_DEFAULT_ORGANIZATION_REQUEST,
    watchUpdateDefaultOrganization,
  );
}

function* watchUpdateDefaultOrganization(action) {
  try {
    const groupMemberId = action.payload;
    yield call(API.groups.updateDefaultExternalShare, { groupMemberId });
    yield put(fetchProfile.request());
    yield put(updateDefaultOrganization.success());
  } catch (e) {
    yield put(updateDefaultOrganization.error(e));
  }
}
